// extracted by mini-css-extract-plugin
export default {"container":"detailCases_container__JxAhl"};